"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    StickyChatBotOpener: ()=>StickyChatBotOpener
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_pcln_icons_namespaceObject = require("pcln-icons");
const external_react_namespaceObject = require("react");
const external_styled_components_namespaceObject = require("styled-components");
var external_styled_components_default = /*#__PURE__*/ __webpack_require__.n(external_styled_components_namespaceObject);
const useSuppressOnNativeWebView_js_namespaceObject = require("./hooks/useSuppressOnNativeWebView.js");
const TRAVEL_BOT_LOGO = 'https://s1.pclncdn.com/design-assets/pcln-bot/logos/pcln_bot_opener_logo_no_border_v1.1.svg';
const CircleCard = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Card).withConfig({
    displayName: "StickyChatBotOpener__CircleCard"
})([
    "width:60px;height:60px;background-color:",
    ";transition:0.2s ease-in-out;border:none;box-shadow:",
    ";&:hover{cursor:pointer;box-shadow:",
    ";}"
], (0, external_pcln_design_system_namespaceObject.getPaletteColor)('primary.base'), ({ theme })=>theme.shadows.md, ({ theme })=>theme.shadows.lg);
const StyledDot = /*#__PURE__*/ external_styled_components_default()(external_pcln_icons_namespaceObject.Dot).withConfig({
    displayName: "StickyChatBotOpener__StyledDot"
})([
    "position:absolute;right:-8px;top:-5px;"
]);
const fadeInFromBottomToTopAnimation = (props)=>{
    const animation = /*#__PURE__*/ (0, external_styled_components_namespaceObject.keyframes)([
        "from{transform:translate(",
        ",",
        ");-webkit-transform:translate(",
        ",",
        ");opacity:0;}to{transform:translate(",
        ",",
        ");opacity:1;}"
    ], props.fromX, props.fromY, props.fromX, props.fromY, props.toX, props.toY);
    return /*#__PURE__*/ (0, external_styled_components_namespaceObject.css)([
        "position:relative;animation:",
        ";animation-duration:0.4s;animation-fill-mode:forwards;animation-timing-function:cubic-bezier(0,0,0.3,1);"
    ], animation);
};
const AnimateBottomToTop = /*#__PURE__*/ external_styled_components_default().div.withConfig({
    displayName: "StickyChatBotOpener__AnimateBottomToTop"
})([
    "",
    " position:absolute;bottom:0;width:100%;height:100%;"
], fadeInFromBottomToTopAnimation);
const AnimateComponent = ({ children, animationProperties, animationType })=>{
    if ('BottomToTop' === animationType) {
        const { bottom, from, to } = animationProperties;
        return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(AnimateBottomToTop, {
            fromX: from.x,
            fromY: from.y,
            toX: to.x,
            toY: to.y,
            bottom: bottom,
            children: children
        });
    }
    return children;
};
const StickyChatBotOpener = (props)=>{
    const { shouldSuppress } = (0, useSuppressOnNativeWebView_js_namespaceObject.useSuppressOnNativeWebView)();
    if (shouldSuppress) return null;
    const { isChatBoxOpened, onComponentRendered, onClickHandler, openerPosition, animationType = 'None', animationProperties } = props;
    const [isTooltipOpen, setIsOpen] = (0, external_react_namespaceObject.useState)(false);
    const [isSectionActive, setIsSectionActive] = (0, external_react_namespaceObject.useState)(false);
    (0, external_react_namespaceObject.useEffect)(()=>{
        onComponentRendered();
    }, []);
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (isChatBoxOpened && !isSectionActive) setIsSectionActive(true);
    }, [
        isChatBoxOpened
    ]);
    function onMouseOver() {
        setIsOpen(true);
    }
    function onMouseOut() {
        setIsOpen(false);
    }
    const openerTooltipProps = props.openerTooltipProps || {};
    const tooltipProps = {
        top: true,
        center: true,
        bg: 'black',
        color: 'white',
        ...openerTooltipProps
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(AnimateComponent, {
        animationType: animationType,
        animationProperties: animationProperties,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(CircleCard, {
            style: {
                position: 'fixed',
                right: '32px',
                bottom: '32px',
                ...openerPosition
            },
            borderRadius: "full",
            "data-testid": "openChatBotDialog",
            onClick: onClickHandler,
            onMouseOver: onMouseOver,
            onMouseOut: onMouseOut,
            children: [
                isTooltipOpen && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Tooltip, {
                    p: 1,
                    style: {
                        bottom: '-2px',
                        ...props.openerTooltipStyle
                    },
                    ...tooltipProps,
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                        width: "110px",
                        children: "Chat with Penny"
                    })
                }),
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Flex, {
                    alignItems: "center",
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Image, {
                        src: TRAVEL_BOT_LOGO,
                        width: 60,
                        alt: "Penny chat opener"
                    })
                }),
                isSectionActive && !isChatBoxOpened && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(StyledDot, {
                    size: 32,
                    color: "warning.tone"
                })
            ]
        })
    });
};
exports.StickyChatBotOpener = __webpack_exports__.StickyChatBotOpener;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "StickyChatBotOpener"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
